<template>
  <div class="graph-area pl-3 pr-4">
    <v-apex-bar-chart
      v-for="(data, index) in graphDatas"
      :key="index"
      :series="data.series"
      :categories="data.categories"
      class="py-0"
      :class="'graph-area__'+(index+1)"
    />
  </div>
</template>

<script>
import VApexBarChart from '@/components/molecules/ApexBarChart'

export default {
  components: {
    VApexBarChart
  },
  computed: {
    graphDatas() {
      return this.$store.getters['sheet/graphDatas']
    }
  }
}
</script>

<style lang="stylus" scoped>
.graph-area
  height 700px
  position relative

  &__1
    position absolute
    width 100%
    top -20px

  &__2
    position absolute
    width 100%
    top calc(100% / 6 * 1 - 20px)

  &__3
    position absolute
    width 100%
    top calc(100% / 6 * 2 - 20px)

  &__4
    position absolute
    width 100%
    top calc(100% / 6 * 3 - 20px)

  &__5
    position absolute
    width 100%
    top calc(100% / 6 * 4 - 20px)

  &__6
    position absolute
    width 100%
    top calc(100% / 6 * 5 - 20px)
</style>
